export default {
  set(state, { data }) {
    state.sazonais = data;
  },
  show(state, { data }) {
    state.sazonal = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}